import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS, REGEX } from "utils/Constants";
import { Image, Linking, Pressable, StyleSheet, View } from "react-native";
import React, { useEffect, useState } from "react";
import { SCREEN_WIDTH, fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { getConfig, resetStoredUtilsSlice } from "appRedux/reducers/storedUtilsSlice";
import { getUserDetails, newsLetterSubscribe, resetProfileSlice } from "appRedux/reducers/profileSlice";
import { resetAuthSlice, setLocalNewsLetterSubscribed } from "appRedux/reducers/authSlice";
import { router, useGlobalSearchParams, useLocalSearchParams, useSegments } from "expo-router";
import { useDispatch, useSelector } from "react-redux";

import AsyncStorage from "@react-native-async-storage/async-storage";
import Buttons from "components/Buttons";
import Input from "components/Input";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig";
import { logEvent } from "firebase/analytics";
import { resetCartSlice } from "appRedux/reducers/cartSlice";
import { resetFilterSlice } from "appRedux/reducers/filterSlice";
import { resetHomeSlice } from "appRedux/reducers/homeSlice";
import { resetOrderSlice } from "appRedux/reducers/orderSlice";
import { resetUtilsSlice } from "appRedux/reducers/utilsSlice";
import { trackV2 } from "utils/Segment";
import { ANALYTICS_EVENT_NAMES } from "utils/analytics";

const NewsLetterCop = () => {
    const dispatch = useDispatch();
    const local = useGlobalSearchParams();
    const gender = local?.gender || "female";
    const [email, setEmail] = useState("");
    const [isEmailError, setIsEmailError] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [isSuccessModal, setIsSuccessModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [hidePadding, setHidePadding] = useState(false);

    const userProfile = useSelector((state) => state.ProfileReducer.profileData);
    const isSubscribed = useSelector((state) => state.ProfileReducer.isSubscribed);
    const userId = useSelector((state) => state.AuthReducer.userId);

    const segments = useSegments();

    useEffect(() => {
        if (segments) {
            const find = segments?.find((o) => ["concierge-Services", "ai-stylist", "men", "videos"]?.includes(o));
            if (find) {
                setHidePadding(true);
            } else {
                setHidePadding(false);
            }
        } else {
            setHidePadding(false);
        }
    }, [segments]);

    const handleSubmit = () => {
        let trimmedEmail = email?.trim();

        if (REGEX.email.test(trimmedEmail)) {
            setIsLoading(true);
            dispatch(newsLetterSubscribe({ emailId: trimmedEmail, gender: gender }))
                .then((res) => {
                    setIsLoading(false);
                    if (res.payload.data.data.statusCode === 200) {
                        logEvent(analytics, FIREBASE_EVENT_NAMES.NEWSLETTER_SUBSCRIBED, {
                            [FIREBASE_EVENT_PARAMS.EMAIL]: res.payload.data?.meta?.request_id,
                        });
                        const eventData = {
                            current_section: gender === "female" ? "Women" : "Men",
                            gender: userProfile?.gender,
                            user_type: userId ? "Registered" : "Guest",
                        };
                        trackV2(ANALYTICS_EVENT_NAMES.NEWSLETTER_SUBSCRIBED, eventData);
                        setIsSuccessModal(true);
                        setTimeout(() => {
                            setIsSuccessModal(false);
                        }, 4000);

                        dispatch(setLocalNewsLetterSubscribed(true));

                        if (userId) {
                            dispatch(getUserDetails(userId));
                        }

                        setEmail("");
                    } else {
                        setErrorText("You are already subscribed to our newsletter with this email.");
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log(err);
                });
        } else {
            setIsEmailError(true);
            setErrorText("Please enter valid email");
        }
        // setIsSuccessModal(true);
    };

    const checkEmailAlreadySubscribed = (email) => {
        let trimmedEmail = email?.trim();

        dispatch(newsLetterSubscribe({ emailId: trimmedEmail, justCheck: true })).then((res) => {
            if (res.payload.data.data.statusCode != 200) {
                setIsEmailError(true);
                setErrorText("You are already subscribed to our newsletter with this email.");
            }
        });
    };

    const handleInputChange = (txt) => {
        let trimmedTxt = txt?.trim();

        if (REGEX.email.test(trimmedTxt) || trimmedTxt?.length === 0) {
            checkEmailAlreadySubscribed(trimmedTxt);
            setIsEmailError(false);
            setErrorText("");
        } else {
            setIsEmailError(true);
            setErrorText("Please enter valid email");
        }
        setEmail(trimmedTxt);
    };

    return (
        <View
            style={{
                paddingTop: hidePadding ? 0 : spV(60),
            }}
        >
            <View style={styles.container}>
                {isSuccessModal ? (
                    <View style={{ ...styles.successModalContainer }}>
                        <View style={{ marginBottom: spV(20) }}>
                            <Image
                                style={{ width: wp(32), height: wp(32) }}
                                source={require("assets/BlackCircleCheck.svg")}
                                accessibilityLabel="Black Circle Check"
                            />
                        </View>
                        <VText style={styles.aboutHeadingText}>Thank You For Signing Up</VText>
                        <VText
                            style={{ ...styles.aboutSubText, fontSize: fp(16), width: wp(650), textAlign: "center" }}
                        >
                            You are now subscribed to our newsletters.
                        </VText>
                    </View>
                ) : isSubscribed && userProfile && !userProfile?.isGuest ? (
                    <View style={{ flex: 1 }}>
                        <VText style={{ marginTop: spV(10), fontWeight: "350", fontSize: fp(28) }}>
                            Hello, {userProfile?.name}
                        </VText>
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                marginTop: spV(10),
                            }}
                        >
                            <Pressable
                                onPress={() => {
                                    router.push(`/profile?gender=${gender}`);
                                }}
                            >
                                <VText style={{ fontWeight: "300", fontSize: fp(20) }}>My Account</VText>
                            </Pressable>
                            <View
                                style={{
                                    height: wp(8),
                                    width: wp(8),
                                    backgroundColor: "#D9D9D9",
                                    borderRadius: 100,
                                    marginHorizontal: spH(12),
                                }}
                            />
                            <Pressable
                                onPress={async () => {
                                    await AsyncStorage.clear();
                                    dispatch(resetAuthSlice());
                                    dispatch(resetCartSlice());
                                    dispatch(resetHomeSlice());
                                    dispatch(resetOrderSlice());
                                    dispatch(resetProfileSlice());
                                    dispatch(resetUtilsSlice());
                                    dispatch(resetStoredUtilsSlice());
                                    dispatch(resetFilterSlice());
                                    router.push("/");

                                    dispatch(getConfig());
                                }}
                            >
                                <VText style={{ fontWeight: "300", fontSize: fp(20) }}>Sign Out</VText>
                            </Pressable>
                        </View>
                    </View>
                ) : (
                    <View style={styles.aboutTextContainer}>
                        <VText style={styles.aboutHeadingText}>Personalized Experience Delivered</VText>
                        <VText style={{ ...styles.aboutSubText }}>
                            Subscribe to our newsletter to get exclusive access to our latest collections, stories and
                            videos.
                        </VText>
                        <View
                            style={{
                                marginTop: spV(20),
                                alignItems: "center",
                                flexDirection: "row",
                            }}
                        >
                            <Input
                                leftIcon={() => (
                                    <View style={{ height: 27, marginRight: 10 }}>
                                        <svg
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M11.9991 11.6075L21.5841 5.45C21.1987 5.16096 20.7308 5.00323 20.2491 5H3.74906C3.26736 5.00323 2.79942 5.16096 2.41406 5.45L11.9991 11.6075Z"
                                                fill={isEmailError ? "#CE1A1A" : "#212427"}
                                                fillOpacity={email?.length > 0 ? "1" : "0.3"}
                                            />
                                            <path
                                                d="M12.405 13.1303L12.2775 13.1903H12.2175C12.1484 13.2212 12.0751 13.2414 12 13.2503V13.2503C11.9377 13.2582 11.8748 13.2582 11.8125 13.2503H11.7525L11.625 13.1903L1.575 6.69531C1.52698 6.87647 1.50179 7.06291 1.5 7.25031V17.7503C1.5 18.347 1.73705 18.9193 2.15901 19.3413C2.58097 19.7633 3.15326 20.0003 3.75 20.0003H20.25C20.8467 20.0003 21.419 19.7633 21.841 19.3413C22.2629 18.9193 22.5 18.347 22.5 17.7503V7.25031C22.4982 7.06291 22.473 6.87647 22.425 6.69531L12.405 13.1303Z"
                                                fill={isEmailError ? "#CE1A1A" : "#212427"}
                                                fillOpacity={email?.length > 0 ? "1" : "0.3"}
                                            />
                                        </svg>
                                    </View>
                                )}
                                containerStyle={{ width: wp(280), color: "#000000", backgroundColor: "#fff" }}
                                showIcon
                                placeholder="Email"
                                inputContainerStyle={{
                                    height: hp(36),
                                    borderColor:
                                        email?.length > 0 ? (isEmailError ? "#CE1A1A" : "#000000") : "#00000029",
                                }}
                                value={email}
                                onChangeText={handleInputChange}
                                propStyle={{
                                    borderRadius: 0,
                                    width: "100%",
                                    color: isEmailError ? "#CE1A1A" : "#212427",
                                    fontSize: fp(12),
                                    outlineStyle: "none",
                                }}
                            />
                            <Buttons
                                disabled={isEmailError || isLoading || email?.length === 0}
                                containerStyle={{
                                    borderRadius: 0,
                                    width: wp(130),
                                    padding: 0,
                                    marginLeft: spH(10),
                                    backgroundColor:
                                        isEmailError || isLoading || email?.length === 0 ? "#2124274D" : "#000000",
                                    height: hp(36),
                                }}
                                loading={isLoading}
                                inputContainerStyle={{
                                    height: hp(36),
                                }}
                                text="Subscribe"
                                textStyle={{
                                    fontSize: fp(16),
                                    fontWeight: "350",
                                    fontFamily: "JosefinSans",
                                }}
                                onPress={() => {
                                    if (REGEX.email.test(email)) {
                                        handleSubmit();
                                    } else {
                                        setIsEmailError(true);
                                        setErrorText("Please enter valid email");
                                    }
                                }}
                            />
                        </View>
                        <View style={{ textAlign: "left", width: wp(480) }}>
                            {errorText && (
                                <VText
                                    style={{
                                        color: "#CE1A1A",
                                        fontFamily: "JosefinSans",
                                        paddingTop: 8,
                                        textAlign: "left",
                                    }}
                                    text={errorText}
                                />
                            )}
                        </View>
                    </View>
                )}
                <View
                    style={{
                        width: (SCREEN_WIDTH - 120) * 0.6,
                        paddingLeft: wp(120),
                    }}
                >
                    <VText style={{ fontSize: fp(16), paddingRight: spV(40) }}>
                        To learn or inquire about ways to partner with us, please email:
                    </VText>
                    <View
                        style={{
                            marginTop: spV(32),
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        <View
                            style={{
                                borderRightWidth: 1,
                                borderColor: "#00000099",
                                paddingRight: spH(20),
                            }}
                        >
                            <VText style={{ fontSize: fp(14), fontWeight: "400" }}>Private Clients</VText>
                            <Pressable
                                onPress={() => {
                                    logEvent(analytics, FIREBASE_EVENT_NAMES.EMAIL_CLICKED, {
                                        [FIREBASE_EVENT_PARAMS.CLICKED_FROM]: "PRIVATE_CLIENTS_EMAIL_CLICKED",
                                    });
                                    Linking.openURL("mailto:concierge@vetirapp.com");
                                }}
                            >
                                <VText style={{ fontSize: fp(12), marginTop: spV(4), fontWeight: "350" }}>
                                    Concierge@vetirapp.com
                                </VText>
                            </Pressable>
                        </View>
                        <View
                            style={{
                                borderRightWidth: 1,
                                borderColor: "#00000099",
                                paddingLeft: spH(20),
                                paddingRight: spH(20),
                            }}
                        >
                            <VText style={{ fontSize: fp(14), fontWeight: "400" }}>Stylist</VText>
                            <Pressable
                                onPress={() => {
                                    logEvent(analytics, FIREBASE_EVENT_NAMES.EMAIL_CLICKED, {
                                        [FIREBASE_EVENT_PARAMS.CLICKED_FROM]: "STYLIST_EMAIL_CLICKED",
                                    });
                                    Linking.openURL("mailto:stylist@vetirapp.com");
                                }}
                            >
                                <VText style={{ fontSize: fp(12), marginTop: spV(4), fontWeight: "350" }}>
                                    Stylist@vetirapp.com
                                </VText>
                            </Pressable>
                        </View>
                        <View
                            style={{
                                paddingLeft: spH(20),
                            }}
                        >
                            <VText style={{ fontSize: fp(14), fontWeight: "400" }}>Designers</VText>
                            <Pressable
                                onPress={() => {
                                    logEvent(analytics, FIREBASE_EVENT_NAMES.EMAIL_CLICKED, {
                                        [FIREBASE_EVENT_PARAMS.CLICKED_FROM]: "DESIGNERS_EMAIL_CLICKED",
                                    });
                                    Linking.openURL("mailto:designer@vetirapp.com");
                                }}
                            >
                                <VText style={{ fontSize: fp(12), marginTop: spV(4), fontWeight: "350" }}>
                                    Designer@vetirapp.com
                                </VText>
                            </Pressable>
                        </View>
                    </View>
                </View>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "rgba(240, 240, 240, 1)",
        paddingVertical: spV(48),
        paddingHorizontal: spH(60),
        flexDirection: "row",
    },
    successModalContainer: {
        flex: 1,
        alignItems: "center",
    },

    aboutTextContainer: {
        width: (SCREEN_WIDTH - 120) * 0.4,
    },
    aboutHeadingText: {
        fontFamily: "LibreBodoni",
        fontSize: fp(20),
        fontWeight: "300",
    },
    aboutSubText: {
        marginTop: spV(10),
        fontSize: fp(14),
        fontWeight: "350",
    },
});

export default React.memo(NewsLetterCop);
